import { useMutation, useQueryClient } from '@tanstack/react-query'
import classNames from 'classnames'
import React, { useCallback, useMemo } from 'react'
import { BiCheck } from 'react-icons/bi'

import { orders } from '../../api/services/orders'
import { OrderExtendedProfile } from '../../api/services/orders/types.ts'

const SaleDocumentCheckbox = ({ row }: { row: OrderExtendedProfile }) => {
  const queryClient = useQueryClient()

  const availableMutate = useMemo(() => {
    return row.status !== 'not_paid' && row.status !== 'canceled' && !row.paid_by_voucher
  }, [row.status])

  const toggleSaleDocument = async () => {
    try {
      await orders.postToggleSaleDocument(row.id)
    } catch (error) {
      console.log('toggleSaleDocument error', error)
    }
  }

  const { mutateAsync } = useMutation({
    mutationFn: toggleSaleDocument,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ordersWithProfiles']})
    }
  })

  const handleClick = useCallback(async () => {
    if (availableMutate) {
      try {
        await mutateAsync()
      } catch {}
    }
  }, [availableMutate, mutateAsync])

  const checkboxClass = classNames(
    'relative flex w-6 h-6 border-4 dark:border-gray-700 dark:bg-gray-600 rounded-md justify-center items-center',
    { 'cursor-pointer': availableMutate }
  )

  return (
    <div
      className="flex justify-center items-center h-full w-full"
      onClick={handleClick}
    >
      <div className={checkboxClass}>
        {row.sale_document_created && (
          <BiCheck
            className="text-green-500 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 scale-150"
            size={22}
          />
        )}
      </div>
    </div>
  )
}
export default SaleDocumentCheckbox
